import styled, { css } from "styled-components";
import { type WidthProps, width } from "styled-system";
import { theme as toyotaTheme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { ColoursWrapper } from "../../../common/extras/styles/AccentColours";
import * as ItemSliderStyles from "../../../../../../../../common-deprecated/styles/toyota/ItemSlider";
import * as CashPriceStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";
import * as MonthlyPriceStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import { parseHexToRGB } from "../../../../../../../../common-deprecated/utils";

export const Header = styled.div<{ hasBackground?: boolean; fullWidthImage?: boolean; hasImage?: boolean }>`
    position: relative;
    margin-bottom: ${toyotaTheme.space[2]}px;
    padding: ${toyotaTheme.space[2]}px ${toyotaTheme.space[3]}px 0;
    ${({ hasBackground, theme }) =>
        hasBackground &&
        css`
            ${ColoursWrapper} {
                padding-bottom: ${theme.space[3]}px;
            }
        `};
    ${({ fullWidthImage, hasImage }) =>
        fullWidthImage &&
        hasImage &&
        css`
            @media ${getBreakpoint("up", "md")} {
                display: flex;
                flex-direction: row;
            }
        `};

    ${CashPriceStyles.Text},
    ${MonthlyPriceStyles.Text} {
        font-family: ${toyotaTheme.fonts.base};
    }
`;

export const ContentWrapper = styled.div<{ isOpen?: boolean }>`
    padding: 0 ${toyotaTheme.space[3]}px ${toyotaTheme.space[3]}px;

    ${ItemSliderStyles.Wrapper} {
        margin-bottom: ${toyotaTheme.space[3]}px;
        @media ${getBreakpoint("up", "lg")} {
            position: relative;
            left: 80px;
            max-width: calc(100% - 80px);
        }
    }

    html[dir="rtl"] & {
        ${ItemSliderStyles.Wrapper} {
            @media ${getBreakpoint("up", "lg")} {
                left: auto;
                right: 80px;
            }
        }
    }
`;

export const Wrapper = styled.div<{
    packIndex: number;
    disableBorder?: boolean;
    selected?: boolean;
    isSinglePack?: boolean;
}>`
    margin-bottom: ${toyotaTheme.space[3]}px;
    background-color: ${toyotaTheme.colors.primaryWhite};
    border-radius: 4px;

    &:last-of-type {
        margin-bottom: 0;
    }

    ${({ selected }) =>
        selected
            ? css`
                  box-shadow: 0 0 0 2px ${toyotaTheme.colors.primaryBlack};

                  /* Custom style for bz4x color theme */
                  .bz & {
                      box-shadow: 0 0 0 2px ${toyotaTheme.colors.bz4x};
                  }
              `
            : css`
                  box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
              `};

    ${({ disableBorder }) =>
        disableBorder &&
        css`
            box-shadow: 0 0 0 2px rgba(${parseHexToRGB(toyotaTheme.colors.grey2).rgb});
        `};

    ${({ isSinglePack }) =>
        isSinglePack &&
        css`
            padding: 0;
            border: none;
            box-shadow: none;

            ${Header},
            ${ContentWrapper} {
                padding-left: 0;
                padding-right: 0;
            }
        `};
`;

export const TitleWrapper = styled.div<{ hasImage: boolean; fullWidthImage?: boolean }>`
    ${({ hasImage, fullWidthImage }) => css`
        /*max-width: 250px;*/
        ${hasImage &&
        !fullWidthImage &&
        css`
            @media ${getBreakpoint("up", "md")} {
                position: absolute;
                bottom: 25px;
            }
        `};
        ${hasImage &&
        fullWidthImage &&
        css`
            padding-right: 0;
            @media ${getBreakpoint("up", "md")} {
                width: 100%;
                max-width: 250px;
            }
        `};
    `};

    ${Type.Text} {
        font-family: ${toyotaTheme.fonts.semiBold};
    }

    html[dir="rtl"] & {
        ${({ hasImage, fullWidthImage }) => css`
            ${hasImage &&
            fullWidthImage &&
            css`
                padding-left: 0;
            `};
        `}
    }
`;

export const Title = styled.h2`
    display: inline-flex;
    gap: ${toyotaTheme.space[1]}px;
    font-family: ${toyotaTheme.fonts.semiBold};
    font-size: 1.7rem;
    line-height: 3rem;
    text-align: start;
    text-transform: none;
`;

export const SubTitle = styled.h3`
    display: flex;
    justify-content: space-between;
    margin: 0 0 ${toyotaTheme.space[3]}px;
    padding: 0;
    font-family: ${toyotaTheme.fonts.base};
    font-size: 1.6rem;
    text-transform: none;
    color: ${toyotaTheme.colors.primaryBlack};
`;

export const Description = styled.div<WidthProps>`
    margin-bottom: ${toyotaTheme.space[2]}px;
    padding-bottom: ${toyotaTheme.space[2]}px;
    font-size: 1.6rem;
    color: ${toyotaTheme.colors.grey4};
    border-bottom: 1px solid ${toyotaTheme.colors.grey2};
    ${width};
`;

export const FootNote = styled.div`
    margin-bottom: ${toyotaTheme.space[2]}px;
    padding: 0 ${toyotaTheme.space[3]}px;
    font-family: ${toyotaTheme.fonts.base};
    font-size: 1.6rem;
    line-height: 2.4rem;
`;

export const PackAction = styled.div<{ isActive?: boolean; hasFootnote?: boolean }>`
    display: flex;
    justify-content: space-between;
    padding: 0 ${toyotaTheme.space[3]}px ${toyotaTheme.space[4]}px;
`;

export const ImageWrapper = styled.div<{ src: any }>`
    width: 100%;
    height: 200px;
    background-image: url(${({ src }) => src && src});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
`;

export const OptionalContainer = styled.div`
    padding: ${toyotaTheme.space[3]}px;
    background-color: ${toyotaTheme.colors.grey1};
`;

export const FooterTitle = styled.h4`
    margin: 0 0 ${toyotaTheme.space[3]}px;
    font-family: ${toyotaTheme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-transform: none;
    color: ${toyotaTheme.colors.primaryBlack};
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: ${toyotaTheme.space[4]}px;

    @media ${getBreakpoint("up", "sm")} {
        grid-template-columns: 1fr 1fr;
    }

    @media ${getBreakpoint("up", "xl")} {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;
